<template>
    <div class="form-group row">
        <div class="col-sm-11">
            <md-field>
                <label>{{name}}</label>
                <md-textarea :class="{ 'is-invalid':validate && validate.$dirty && validate.$invalid && !disabled,
                'mdTextAreaNotEmpty': validate.$model != null}"
                             :disabled="disabled"
                             :required="required"
                             class="form-control "
                             md-autogrow
                             v-model="val">
                </md-textarea>
            </md-field>
        </div>
        <span style="display: none" v-if="validate">{{validate.$model}}</span>
    </div>
</template>

<script>

    import {titles} from '../../utils/general/titles';

    export default {
        name: 'Textarea',
        props: {
            name: String,
            icon: String,
            inputKey: String,
            validate: Object,
            type: String,
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                titles,
                val: this.validate ? this.validate.$model : null,
                required: this.validate != undefined && this.validate.required != undefined
            };
        },
        updated() {
            this.val = this.validate ? this.validate.$model : null;
        }
    };
</script>

<style scoped>
    @import '../../assets/style/css/base.css';
</style>
